import { GetAccountInfo } from "./GetLoginData";

export function AppleSignIn(idToken, callback = () => {}) {
    console.log("apple sign in");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
        IdentityToken: idToken,
        TitleId: "29001",
        CreateAccount: "true",
    });

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
    };

    fetch(
        "https://29001.playfabapi.com/Client/LoginWithApple",
        requestOptions
    )
        .then((response) => response.text())
        .then((result) => {
            GetAccountInfo(result, 'apple', handleGotAccountInfo)
        })
        .catch((error) => console.log("error", error));

    callback(true);
}

function handleGotAccountInfo () {
    window.location.href = process.env.REACT_APP_API_URL + "/Profile";
}